/**
 * @fileoverview Zod schema for the TenantDetailModal "Schedule Follow-up" form.
 * @description A single mandatory date/time field. Every issue message is a translation key (per
 * this repo's i18n rule for validators), translated only at the display call site in
 * ScheduleFollowUpForm.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { z } from 'zod'

export const scheduleFollowUpFormSchema = z.object({
  nextFollowUpAt: z.string().trim().min(1, 'sales.tenantDetail.followUp.errors.dateRequired'),
})

export type ScheduleFollowUpFormValues = z.infer<typeof scheduleFollowUpFormSchema>
